module.exports = __webpack_public_path__ + "img/brand (14).f8485dc5.svg";